import {useBreakpoints} from '@vueuse/core';
import {mapValues} from 'lodash-es';
import {screens} from '@/config/tailwind';

export default function useTailwindBreakpoints() {
	return useBreakpoints(mapValues(screens, (value: string) => parseInt(value)), {ssrWidth: 900});
}
